export function normalizeOptionsSource(source = ""): string {
  return source
    .trim()
    .replace(/^https?:\/\/[^/]+\//, "")
    .replace(/^\/+/, "")
    .replace(/^api\/v\d+\//, "");
}

export function normalizePaymentTiming(raw?: unknown): string {
  if (!raw && raw !== 0) return "";
  const timing = String(raw).trim().toUpperCase().replace(/\s+/g, "_");
  if (timing.includes("PRE")) return "PRE_MATCH";
  if (timing.includes("POST")) return "POST_MATCH";
  return timing.replace(/[^A-Z0-9_]/g, "");
}
